import {
  csColorAction,
  csColorBackground,
  csColorBorder,
  csColorFunctional,
  csColorText,
} from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { parseCssVariable } from 'elements/_style-guide/parse-css-variable.js'
import { wrapCustomCss } from 'elements/_style-guide/wrap-custom-css.js'
import { CSSResult, CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { style } from './colors.style.js'


type ColorCategory = [name: string, group: Record<string, CSSResult>]
type ColorGroup = [name: string, cssResult: CSSResult]


@customElement('cssg-colors')
export class CSSGColors extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: Object, attribute: 'action' })
  customAction: object = {}
  @property({ type: Object, attribute: 'border' })
  customBorder: object = {}
  @property({ type: Object, attribute: 'background' })
  customBackground: object = {}
  @property({ type: Object, attribute: 'text' })
  customText: object = {}
  @property({ type: Object, attribute: 'functional' })
  customFunctional: object = {}

  private colorCategories: Record<string, Record<string, CSSResult>> = {}

  override connectedCallback() {
    super.connectedCallback()
    this.colorCategories = {
      action: { ...csColorAction, ...wrapCustomCss(this.customAction) },
      border: { ...csColorBorder, ...wrapCustomCss(this.customBorder) },
      background: { ...csColorBackground, ...wrapCustomCss(this.customBackground) },
      text: { ...csColorText, ...wrapCustomCss(this.customText) },
      functional: { ...csColorFunctional, ...wrapCustomCss(this.customFunctional) },
    }
  }

  private renderGroup = ([name, cssResult]: ColorGroup) => {
    const parsedCssVariable = parseCssVariable(cssResult.cssText, this)
    return html`
      <div>
        <div class="swatch" style="background-color: ${cssResult};">
          ${parsedCssVariable.value}
        </div>
        <cse-text variant="heading-4" class="swatch-title">
          ${name}
        </cse-text>
        <cse-text variant="body-s">
          ${parsedCssVariable.variable}
        </cse-text>
      </div>
    `
  }

  private renderCategory = ([name, group]: ColorCategory) => {
    return html`
      <cse-text variant="caption-m" class="swatch-group-name">
        ${name}
      </cse-text>
      <div class="swatch-group">
        ${Object.entries(group).map(this.renderGroup)}
      </div>
      <div class="divider"></div>
    `
  }

  override render() {
    return Object.entries(this.colorCategories).map(this.renderCategory)
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'cssg-colors': CSSGColors
  }
}
